import { round } from 'lodash';

export const precisionAddition = (a, b) => round(a + b, 10);
